import React, { Fragment } from 'react';
import styles from '../../styles/modules/common/media.module.scss';
import Image from '../common/Image'
import Button from '../common/ui-components/input/Button';
import { formatDate } from '../../utils';
import moment from 'moment';
import parse from 'html-react-parser'

const News = (props) => {
    const { image,title, published_date,news_source, description, link,id } = props;

    return(
        <Fragment>
            <div className={`container ${styles.news__div}`} key={id}>
                <div className={`row`}>
                    <div className={`col-12 col-md-4 col-lg-4 ${styles.news__image}`}>
                        <Image src={ image || "/static/images/aboutus/accel.svg" } width="373" height="373"/>
                    </div>
                    <div  className={`col-12 col-md-8 col-lg-8 ${styles.news__content}`}>
                       <div className={`${styles.news__info}`}>
                           <p>{news_source}</p>
                           <div className={`${styles.news__bluedot}`}></div>
                           <p>{ formatDate(moment(published_date,'YYYY-MM-DD'),"MMM DD YYYY")}</p>
                       </div>
                       <h3 className={`${styles.news__heading}`}>{title}</h3>
                       <p className={`${styles.news__description}`}>
                       {parse(description)}
                       </p>
                       <Button className={`${styles.news__source}`} onClick={()=>{window.open(link, "noopener,noreferrer"), window.opener = null}} > Read More </Button>
                    </div>
                </div>
            </div>
                </Fragment>
    )
}

export default News;

